import { Controller } from '@hotwired/stimulus'
import Cropper from 'cropperjs'

// Square-crops an image without processing it: the selection's natural-pixel
// coordinates are written to hidden fields and applied server-side at render.
export default class extends Controller {
  static targets = ['input', 'image', 'container', 'cropX', 'cropY', 'cropWidth', 'cropHeight']
  static values = { crop: Array }

  connect() {
    if (this.imageTarget.getAttribute('src')) {
      this.start(this.savedCropData())
    }
  }

  disconnect() {
    this.stop()
    this.revokeObjectUrl()
  }

  // A Turbo morph (e.g. the redirect back after saving) strips the cropper's
  // injected DOM without re-firing connect, so rebuild from the morphed HTML
  reconnect() {
    this.disconnect()
    this.connect()
  }

  // Replaces the cropper's image with the newly chosen file
  load() {
    const file = this.inputTarget.files[0]
    if (!file) return

    this.stop()
    this.revokeObjectUrl()

    this.objectUrl = URL.createObjectURL(file)
    this.imageTarget.src = this.objectUrl
    this.containerTarget.classList.remove('hidden')
    this.start()
  }

  start(data = undefined) {
    this.cropper = new Cropper(this.imageTarget, {
      aspectRatio: 1,
      viewMode: 1,
      autoCropArea: 1,
      checkCrossOrigin: false,
      movable: false,
      rotatable: false,
      scalable: false,
      zoomable: false,
      data,
      crop: () => this.writeCrop()
    })
  }

  stop() {
    if (this.cropper) {
      this.cropper.destroy()
      this.cropper = null
    }
  }

  writeCrop() {
    const { x, y, width, height } = this.cropper.getData(true)

    this.cropXTarget.value = x
    this.cropYTarget.value = y
    this.cropWidthTarget.value = width
    this.cropHeightTarget.value = height
  }

  savedCropData() {
    if (this.cropValue.length !== 4) return undefined

    const [x, y, width, height] = this.cropValue
    return { x, y, width, height }
  }

  revokeObjectUrl() {
    if (this.objectUrl) {
      URL.revokeObjectURL(this.objectUrl)
      this.objectUrl = null
    }
  }
}
